import { colors } from '@nerdwallet/base-styles/variables';
var AO_COLORS = {
  DEFAULT: colors['neutral-lighter'],
  DEFAULT_BACKGROUND: colors['neutral-lightest']
};
/**
 * Return a style to create the appearance of a segmented bar.
 *
 * @param {string} color - fill color of each segment
 * @param {string} backgroundColor - color of the LOA container's background, for the fill between each segment
 * @param {number} numSegments - the number of total segments to create
 * @return {string} CSS property and value for repeating-linear-gradient
 */

var gradientStringBuilder = function gradientStringBuilder(color) {
  var backgroundColor = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : AO_COLORS.DEFAULT_BACKGROUND;
  var numSegments = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

  // avoid 'divide by zero' errors
  if (numSegments === 0) {
    return 'transparent';
  } // We only want space between the segments
  // | segment |  spacing  | segment |
  // Using a repeating linear gradient we can specify a pattern with the start and end of two colors
  // | segment |  spacing  | segment |
  // |st     sp|st       sp| repeats...   (st = start, sp = stop)
  // To calculate the start and stop positions, split the entire element into num segments
  // | segment | 1px | 1px | segment |
  // |     50%       |       50%     |
  // |st     sp|st       sp| repeats...   (st = start, sp = stop)
  // Then we can see that:
  // the first stop and second start are at (50% - 1px)
  // the second stop is (50% + 2px)
  // Below is the math that calculates these for any number of segments with 4px between them
  // For spacingPxBetweenSegments and segmentPercentageWidth, round to 2 decimals
  // note + prefix to coerce toFixed string back to a number


  var spacingPx = 4;
  var spacingPxBetweenSegments = +(spacingPx / numSegments * (numSegments - 1)).toFixed(2);
  var segmentPercentageWidth = numSegments < 1 ? 100 : +(100 / numSegments).toFixed(2);
  var segmentWidth = "calc(".concat(segmentPercentageWidth, "% - ").concat(spacingPxBetweenSegments, "px)");
  return "repeating-linear-gradient(90deg,".concat(color, ",").concat(color, " ").concat(segmentWidth, ",").concat(backgroundColor, " ").concat(segmentWidth, ",").concat(backgroundColor, " calc(").concat(segmentWidth, " + ").concat(spacingPx, "px))");
};

export default gradientStringBuilder;